import { render, staticRenderFns } from "./fr-CA.vue?vue&type=template&id=a901f524&"
import script from "./fr-CA.vue?vue&type=script&lang=js&"
export * from "./fr-CA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a901f524')) {
      api.createRecord('a901f524', component.options)
    } else {
      api.reload('a901f524', component.options)
    }
    module.hot.accept("./fr-CA.vue?vue&type=template&id=a901f524&", function () {
      api.rerender('a901f524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/fr-CA.vue"
export default component.exports